import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "text-h5 text-center" }, "Задайте новый пароль", -1)

import { ref } from 'vue'
import { UsersService, AppAuthService } from '@prodcard/core'
import { useVuelidate } from '@vuelidate/core'
import { required, helpers, sameAs } from '@vuelidate/validators'
import { createCtx, handleError } from '../../../helpers'
import { VPasswordField } from '../../../components'
import { refObservableValue } from '../../../common'


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordChangeForm',
  props: {
    authService: {},
    usersService: {}
  },
  emits: ["changed"],
  setup(__props: any, { emit }) {

const props = __props;




const user = refObservableValue(props.authService.authorizedUser)
const loading = ref(false)
const password = ref('')
const passwordConfirmation = ref('')

const validator = useVuelidate(
  {
    password: {
      required: helpers.withMessage('Пароль не может быть пустым', required),
      sameAs: helpers.withMessage('Пароли не совпадают', sameAs(passwordConfirmation)),
    },
    passwordConfirmation: {
      sameAs: helpers.withMessage('Пароли не совпадают', sameAs(password)),
    },
  },
  { password, passwordConfirmation },
)

const changePassword = async () => {
  handleError(async () => {
    const valid = await validator.value.$validate()
    if (!valid || !user.value) return

    await props.usersService.update(createCtx(), user.value.id, { password: password.value })
    emit('changed')
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    loading: loading.value,
    disabled: loading.value,
    elevation: "3",
    variant: "flat",
    class: "pa-5"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            onSubmit: _withModifiers(changePassword, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        "model-value": _unref(user)?.email,
                        readonly: ""
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VPasswordField), {
                        modelValue: password.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                        label: "Пароль*",
                        "error-messages": _unref(validator).password.$errors.map(e => e.$message).join(', ')
                      }, null, 8, ["modelValue", "error-messages"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VPasswordField), {
                        modelValue: passwordConfirmation.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordConfirmation).value = $event)),
                        label: "Подтвердите пароль",
                        "error-messages": _unref(validator).passwordConfirmation.$errors.map(e => e.$message).join(', ')
                      }, null, 8, ["modelValue", "error-messages"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        type: "submit",
                        loading: loading.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Сохранить ")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading", "disabled"]))
}
}

})